import { env } from '@/config/env'
import { paths } from '@/config/paths'
import Axios from 'axios'

// リフレッシュ処理の状態管理
let isRefreshing = false
let waitQueue: Array<{
  resolve: (value: any) => void
  reject: (reason?: any) => void
  request: any
}> = []

// Cookie認証チェック関数
export const isAuthTokenValid = (): boolean => {
  if (typeof document === 'undefined') return false

  try {
    const cookies = document.cookie.split(';')
    const accessTokenCookie = cookies.find((cookie) => cookie.trim().startsWith('access_token='))

    if (!accessTokenCookie) return false

    const accessToken = accessTokenCookie.split('=')[1]
    if (!accessToken) return false

    const parts = accessToken.split('.')
    if (parts.length !== 3) return false

    const payload = JSON.parse(atob(parts[1]))
    const currentTime = Math.floor(Date.now() / 1000)

    return payload.exp && payload.exp > currentTime
  } catch (error) {
    console.error('Error checking auth token validity:', error)
    return false
  }
}

// ログインページにリダイレクト
const redirectToLogin = (): void => {
  const currentPath = window.location.pathname + window.location.search
  window.location.href = paths.auth.login.getHref(currentPath)
}

// 待機キューの処理
const processWaitQueue = (error?: any): void => {
  waitQueue.forEach(({ resolve, reject, request }) => {
    if (error) {
      reject(error)
    } else {
      resolve(api.request(request))
    }
  })
  waitQueue = []
}

export const api = Axios.create({
  baseURL: env.API_URL,
  withCredentials: true,
  headers: { Accept: 'application/json' },
})

// レスポンスインターセプター（受信後の処理）
api.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const originalRequest = error.config

    // 401エラーでない場合、またはすでにリトライ済みの場合は早期リターン
    if (error.response?.status !== 401 || !originalRequest || originalRequest._retry) {
      return Promise.reject(error)
    }

    // リフレッシュ中の場合は待機キューに追加
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        waitQueue.push({ resolve, reject, request: originalRequest })
      })
    }

    // リフレッシュ処理開始
    originalRequest._retry = true
    isRefreshing = true

    try {
      console.log('Access token expired, attempting to refresh...')

      // リフレッシュトークンを使用してアクセストークンを更新
      await api.post('/admin/auth/refresh')

      console.log('Token refresh successful')

      // 待機中のリクエストを再実行
      processWaitQueue()

      // 元のリクエストを再実行
      return api.request(originalRequest)
    } catch (refreshError) {
      console.error('Token refresh failed:', refreshError)

      // 待機中のリクエストすべてを拒否
      processWaitQueue(refreshError)

      // リフレッシュが失敗したらログインページにリダイレクト
      console.log('Redirecting to login page...')
      redirectToLogin()

      return Promise.reject(refreshError)
    } finally {
      isRefreshing = false
    }
  },
)
